'use client';

import { getDeliveryMethodsList } from '../lib';
import { useMiniPdpDrawer } from './use-mini-pdp-drawer';
import { useQueryMiniPdpBase } from './use-query-mini-pdp-base';
import { useQueryMiniPdpTailored } from './use-query-mini-pdp-tailored';

export const useMiniPdpProduct = () => {
    const isOpen = useMiniPdpDrawer(state => state.isOpen);
    const productId = useMiniPdpDrawer(state => state.productId);

    const baseQuery = useQueryMiniPdpBase();
    const productData = baseQuery.data?.data;
    const defaultVariant = productData?.variants[productData.defaultSku];
    const isInvalidBase = Boolean(productData) && !defaultVariant;
    const base = isOpen && productId && productData && !isInvalidBase ? productData : null;

    const deliveryMethodsList = base ? getDeliveryMethodsList(base) : [];
    const shouldFetchTailored = Boolean(base) && deliveryMethodsList.length > 0;

    const tailoredQuery = useQueryMiniPdpTailored({
        deliveryMethodsList: shouldFetchTailored ? deliveryMethodsList : [],
        variantSkus: base ? Object.keys(base.variants) : [],
    });

    const isBaseLoading =
        Boolean(isOpen && productId) &&
        !base &&
        !isInvalidBase &&
        !baseQuery.isError &&
        (baseQuery.isPending || baseQuery.isFetching);
    const isTailoredLoading =
        shouldFetchTailored &&
        !tailoredQuery.data &&
        !tailoredQuery.isError &&
        (tailoredQuery.isPending || tailoredQuery.isFetching || tailoredQuery.isLoading);

    const isTailoredError = shouldFetchTailored && tailoredQuery.isError;
    const isUnexpectedError = baseQuery.isError || isTailoredError;

    return {
        base,
        tailored: shouldFetchTailored && !isTailoredError ? (tailoredQuery.data ?? null) : null,
        isLoading: isBaseLoading || isTailoredLoading,
        isError: isUnexpectedError || isInvalidBase,
        isUnexpectedError,
    };
};
